import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { FundingAmount } from './FundingAmount'
import { ImplementationContract } from './ImplementationContract'
import { InitializationCalldata } from './InitializationCalldata'
import { ExtraInitializationParams } from './ExtraInitializationParams'

// "SecondaryContractDeployment": {
//   "fundingAmount": 0,
//   "implementationContract": "0x91488301...",
//   "initializationCalldata": "0x91488301...",
//   "addPrimaryContractAddress": true,
//   "extraInitializationParams": "0x", // 0x
// },

export const SecondaryContractDeploymentPropsSchema = z.object({
  fundingAmount: z.instanceof(FundingAmount),
  implementationContract: z.instanceof(ImplementationContract),
  initializationCalldata: z.instanceof(InitializationCalldata),
  addPrimaryContractAddress: z.boolean(),
  extraInitializationParams: z.instanceof(ExtraInitializationParams),
})

export type SecondaryContractDeploymentProps = z.infer<
  typeof SecondaryContractDeploymentPropsSchema
>

export class SecondaryContractDeployment extends ValueObject<SecondaryContractDeploymentProps> {
  public getFundingAmount(): FundingAmount {
    return this.props.fundingAmount
  }

  public getImplementationContract(): ImplementationContract {
    return this.props.implementationContract
  }

  public getInitializationCalldata(): InitializationCalldata {
    return this.props.initializationCalldata
  }

  public getAddPrimaryContractAddress(): boolean {
    return this.props.addPrimaryContractAddress
  }

  public getExtraInitializationParams(): ExtraInitializationParams {
    return this.props.extraInitializationParams
  }

  public static create(
    props: SecondaryContractDeploymentProps
  ): SecondaryContractDeployment {
    const validatedProps = SecondaryContractDeploymentPropsSchema.parse(props)
    return new SecondaryContractDeployment(validatedProps)
  }
}
